import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Tooltip, Paper } from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import { BulletinItem } from "../../utils/BulletinBoardAPIRequest";
import { useTheme } from "@mui/material/styles"

interface Props {
    items: BulletinItem[];
    onEdit: (item: BulletinItem) => void;
    onDelete: (id: string) => void;
}


const BulletinBoardList: React.FC<Props> = ({ items, onEdit, onDelete }) => {
    const theme = useTheme();
    return (
        <TableContainer
            component={Paper}
            elevation={2}
            sx={{
                borderRadius: 1,
                boxShadow: 3,
                width: '100%',
                maxWidth: 1200,
                mx: 'auto',
                mt: 4,
                mb: 4,
            }}
        >
            <Table sx={{ minWidth: 900 }} aria-label="bulletin table">
                <TableHead>
                    <TableRow sx={{ background: `linear-gradient(135deg,${theme.palette.primary.main},${theme.palette.primary.dark})` }}>
                        <TableCell sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>Title</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>Content</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 600, fontSize: 16 }}>Created At</TableCell>
                        <TableCell sx={{ color: 'white', fontWeight: 600, fontSize: 16, minWidth: 120 }}>Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                                <span style={{ color: '#888', fontSize: 16 }}>No bulletin items.</span>
                            </TableCell>
                        </TableRow>
                    ) : (
                        items.map((item) => (
                            <TableRow key={item._id} hover>
                                <TableCell>
                                    <span style={{ fontWeight: 500 }}>{item.title}</span>
                                </TableCell>
                                <TableCell>{item.content}</TableCell>
                                <TableCell>{(() => {
                                    const d = new Date(item.createdAt);
                                    const day = String(d.getDate()).padStart(2, '0');
                                    const month = String(d.getMonth() + 1).padStart(2, '0');
                                    const year = d.getFullYear();
                                    const time = d.toLocaleTimeString();
                                    return `${day}/${month}/${year} ${time}`;
                                })()}</TableCell>
                                <TableCell>
                                    <div style={{ display: 'flex', gap: 8 }}>
                                        <Tooltip title="Edit">
                                            <IconButton color="primary" onClick={() => onEdit(item)} size="small">
                                                <Edit />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                            <IconButton color="error" onClick={() => onDelete(item._id)} size="small">
                                                <Delete />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default BulletinBoardList;
